import { createContext, useContext } from "react";
export var WebgateAuthContext = createContext(undefined);
export function useWebgateAuth() {
    var ctx = useContext(WebgateAuthContext);
    if (!ctx) {
        throw new Error("useWebgateAuth deve ser usado dentro de WebgateAuthProvider");
    }
    return ctx;
}
